var ModerationAPI = require("./ModerationAPIModel");

// The root require will have the basic getMessages call, but other calls
// will eventually be accessible.  To keep everything at the same level,
// the getMessages call will be available there too.
ModerationAPI.getMessages = ModerationAPI;

module.exports = ModerationAPI;